<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
        </div>
      </v-col>
      <v-col cols="6">
        <v-btn
          class="text-right"
          style="width:250px; background-color: #ffcccc; color: #000000;"
          @click="logout"
        >
          Logout
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>January 7 to 11, 2026 - CES Las Vegas (Arrive Sydney Jan 13)</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/cesvegas">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>   
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>February 5 to 11, 2026 - Super Bowl LX View Party - Caesars Palace (Arrive Sydney Feb 13)</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/superbowlvegas">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>   
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>February 26 to March 18, 2026 - Birthday NRL Trip/UK/NASCAR (Arrive Sydney March 20)</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/marchvegas">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>May 8 to 11, 2026 - New Zealand (Arrive Sydney May 11)</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/newzealand">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            New Zealand
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>May 12 to 17, 2026 - No Doubt at the sphere (Arrive Sydney May 19)</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/nodoubtvegas">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/archive">
          <v-btn
            color="secondary"
            class="text-right"
            style="width:250px"
          >
            Archive
          </v-btn>
        </router-link>
      </v-col>
    </v-row>      
  </v-container>
</template>

<script>

//vue 3 style
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import store from '../store/index.js'

export default {
  name: 'HomeView',
  setup() {
    const router = useRouter()

    const logout = () => {
      store.dispatch('logout')
      router.push({ name: 'home' })
    }

    return {
      logout
    }
  }
}
</script>